/**
 * 跨浏览器/跨协议（HTTP/HTTPS）复制文本到剪贴板
 *
 * navigator.clipboard 在非安全上下文（非 localhost 的 HTTP）下经常不可用，
 * 因此先尝试现代 API，失败时回退到隐藏的 textarea + document.execCommand('copy')。
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (!text) return false

  // 1) 优先使用现代 Clipboard API
  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // 继续 fallback
    }
  }

  // 2) Fallback：textarea + execCommand（兼容 HTTP 与旧浏览器）
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'fixed'
  textarea.style.top = '-9999px'
  textarea.style.left = '-9999px'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)

  try {
    textarea.focus()
    textarea.select()
    // 兼容 iOS
    textarea.setSelectionRange(0, text.length)
    const ok = document.execCommand('copy')
    return ok
  } catch {
    return false
  } finally {
    document.body.removeChild(textarea)
  }
}
